export const forsideResponse = {
  artikkelSideTilbakeKnapp: 'Tilbake til forrige side',
  undertittel: 'Signering av avtale om støtte for elever under 18 år i videregående opplæring',
  standardingress: {
    value:
      '<p>Her finner du avtale om st&oslash;tte som skal signeres for elever under 18 &aring;r i videreg&aring;ende oppl&aelig;ring.</p>',
  },
  tittelIngenAvtaler: 'Det er ingen avtale om støtte som skal signeres.',
  standardtekst: {
    value:
      '<p>En forelder/verge skal signere avtalen om st&oslash;tte til barn under 18 &aring;r. Det holder at &eacute;n forelder/verge signerer avtalen. Du signerer enkelt, med BankID. Klikk p&aring; avtalen og f&oslash;lg oppskriften p&aring; hvordan du skal signere.</p>\n<h2>Du har f&aring;tt kopi av vedtaksbrevet</h2>\n<p>Foreldre med foreldreansvar f&aring;r tilsendt kopi av barnets vedtaksbrev enten i posten eller i elektronisk postkasse (Digipost eller e-Boks). Har du ikke digital postkasse, kan du opprette dette p&aring; norge.no. Eleven kan lese vedtaksbrevet p&aring; Dine sider p&aring; lanekassen.no og f&oslash;lge saken sin der.</p>\n<h2>Ny innvilget s&oslash;knad kan f&oslash;re til ny avtale</h2>\n<p>S&oslash;ker eleven p&aring; nytt og f&aring;r innvilget denne s&oslash;knaden, kan en&nbsp;ny avtale om st&oslash;tte m&aring;tte signeres. Eleven m&aring; for eksempel s&oslash;ke p&aring; nytt n&aring;r hun/han bytter skole.</p>',
  },
  tekstIngenAvtaler: {
    value:
      '<p>&Aring;rsaken kan v&aelig;re:</p>\n<ul>\n<li>Det er ikke blitt laget en avtale som kan signeres enn&aring;</li>\n<li>Du som forelder har ikke logget inn med din egen p&aring;loggingsinformasjon. Navnet ditt skal st&aring; oppe til venstre</li>\n<li>Avtalen om st&oslash;tte kan ikke signeres elektronisk fordi du ikke er registrert med foreldreansvar i folkeregisteret</li>\n<li>Barnet ditt har f&aring;tt innvilget l&aring;n, og dere m&aring; signere p&aring; papir</li>\n</ul>\n<p>Foreldresigneringsiden viser bare avtaler om st&oslash;tte for barn under 18 &aring;r. Dersom du har s&oslash;kt om st&oslash;tte til egen utdanning, kan du ikke signere avtalen her. G&aring; til Dine sider p&aring; lanekassen.no.</p>',
  },
  tittelTilSignering: 'Til signering',
  tittelSignert: 'Avtale om støtte for',
  forklaringFlereAvtaler: { value: '<p>Ingen avtale er signert, men velg den nyeste.</p>' },
  forklaringTidligereAvtaler: {
    value:
      '<p>For hver s&oslash;knad som blir innvilget lager vi en ny avtale om st&oslash;tte. Har eleven s&oslash;kt mer enn en gang, for eksempel ved bytte av skole, lager vi en ny avtale. Som hovedregel skal den nyeste avtalen signeres. Er det ingen avtale under tittelen &laquo;Til signering&raquo;, er den nyeste avtalen signert og du skal ikke signere eldre, usignerte avtaler.</p>',
  },
  forklaringNyereAvtalerSignert: { value: '<p>Flere avtaler til signering, nyeste ikke signert</p>' },
  signertLabel: 'Signert',
  signertAvLabel: 'av  ',
  signertPaPapirLabel: 'Avtalen er signert på papir',
  tittelAvtale: 'Avtale om støtte for',
  datoOpprettet: 'Opprettet',
  larested: 'Lærested',
  belop: 'Beløp',
  avtaleStatus: 'Status',
  lenkeTilSignertAvtale: 'Les avtalen om støtte',
  avtaleStatusSignertPaPapir: 'Signert på papir',
  tittelSeTidligereAvtaler: 'Se tidligere avtaler',
  tekstForSignerLink: 'Dette er en eldre avtale, som hovedregel skal bare nyeste avtale signeres',
  signerLinkTekst: 'Signer eldre avtale ',
  usignertStatus: 'Ikke signert',
  avtaleSeksjonTittel: 'Signerte avtaler',
  tidligereAvtaleModalTittel: 'Du har valgt en gammel avtale',
  tidligereAvtaleModalTekst: {
    value:
      '<p>Det finnes en nyere avtale som er signert, eller som er til signering. For hver innvilget s&oslash;knad blir det laget en avtale om st&oslash;tte. Den sist opprettede avtalen om st&oslash;tte er avtalen for den siste s&oslash;knaden vi har innvilget. Hvis eleven ikke skal g&aring; p&aring; den skolen og/eller ta den utdanningen han/hun har s&oslash;kt om l&aring;n og stipend til sist, kan du signere en eldre avtale.</p>',
  },
  tidligereAvtaleModalSigneringLenkeTekst: 'Jeg vil signere denne',
  tidligereAvtaleModalAvbrytLenkeTekst: 'Gå tilbake til forsiden',
  globalFeilmelding: {
    value:
      '<p><strong>Fredag 26.08.2022:</strong> Det er problemer med &aring; signere avtale om st&oslash;tte n&aring;.&nbsp; Dersom du f&aring;r en 404-melding n&aring;r du skal signere, m&aring; du pr&oslash;ve igjen senere. Vi jobber med &aring; rette feilen, men kan forel&oslash;pig ikke si noe om n&aring;r den er rettet.&nbsp;</p>',
  },
  globalNotabenemelding: {
    value: '<p>Alle foreldre kan få gratis is i perioden 16.06-26.06</p>',
  },
  meldingAvtalePaPapir: {
    value: '<p>N&aring;r elever er under 18 &aring;r skal en av foreldrene signere avtalen om st&oslash;tte.</p>',
  },
  meldingSignertEldreAvtale: { value: '<p>Du har signert en eldre avtale</p>' },
  meldingNyAvtaleTilSignering: { value: '<p>Det er en nyere avtale til signering.</p>' },
  meldingTekniskFeilAvtaleTilSignering: {
    value:
      '<p>Beklager, p&aring; grunn av en teknisk feil kan vi ikke vise deg avtaler til signering. Vennligst kom tilbake seinere.</p>',
  },
  meldingTekniskFeilSignerteAvtaler: {
    value:
      '<p>Beklager, p&aring; grunn av en teknisk feil kan vi ikke vise deg signerte avtaler. Vennligst kom tilbake seinere.</p>',
  },
  meldingTekniskFeilSigner: 'Noko gjekk gale, vennligst prøv på nytt seinere',
  tittelSignereGammelAvtale: { value: '<p>Du signerer n&aring; en gammel avtale.</p>' },
  tekstSignereGammelAvtale: { value: '<p>Hvorfor gj&oslash;r du det? Det er en nyere avtale.</p>' },
  gaVidereSignereGammelAvtale: 'Gå videre allikevel',
  avbrytSignereGammelAvtale: 'Avbryt',
  meldingFontStorrelse: {
    value: '<p>For &aring; &oslash;ke skriftst&oslash;rrelsen trykk Ctrl+. P&aring; Mac Cmd+.</p>',
  },
  loggUtLenkeTekst: 'Logg ut',
  signeringUndertittel: 'Signering av avtale om støtte for elever under 18 år i videregående opplæring',
  signerAvtaleTekst: 'Gå videre til signering',
  vellykketSigneringOverskrift: 'Avtalen er signert',
  vellykketSigneringUndertittel: 'Eleven kan følge status for utbetaling på Dine sider.',
  avbruttSigneringOverskrift: 'Du har avbrutt signeringen',
  avbruttSigneringUndertittel: 'Avtalen er ikke signert',
  feiletSigneringOverskrift: 'Avtalen ble ikke signert',
  feiletSigneringTekst: {
    value:
      '<p>Det er dessverre en feil som gj&oslash;r at du ikke f&aring;r signert avtalen n&aring;. Vennligst ta kontakt med oss, s&aring; kan vi hjelpe deg videre.&nbsp;</p>',
  },
  bekreftelseLastNedSignertDokumentLenkeTekst: 'Last ned avtalen',
  bekreftelseTilbakeTilForsidenLenkeTekst: 'Tilbake til forsiden',
  footerSoyle1: [
    {
      text: 'Personvern',
      href: 'https://localhost:11443/nb-NO/regelverk/andre-regler/personvernerklaring/',
      title: 'Personvern',
      target: '_blank',
      attributes: { title: 'Personvern', target: '_blank', href: '~/link/bfecba64e1a04a0b88afc559bb190ff6.aspx' },
    },
  ],
  footerSoyle2: [
    {
      text: 'www.lanekassen.no',
      href: 'https://localhost:11443/nb-NO/',
      title: 'Lånekassen',
      target: '_blank',
      attributes: { title: 'Lånekassen', target: '_blank', href: '~/link/f6a2bbddc9e949adbd42e22ed51acd8e.aspx' },
    },
  ],
  footerSoyle3: [
    {
      text: 'Endre samtykke instillingene dine',

      href: 'javascript:window.visSamtykkeBanner()',
      title: 'Endre samtykke instillingene dine',
      target: '_blank',
      attributes: { title: 'Lånekassen', target: '_blank', href: '~/link/f6a2bbddc9e949adbd42e22ed51acd8e.aspx' },
    },
  ],
  toggleNavigation: null,
  mobilMenyOverskriftSprak: 'Språk',
  mobilMenyOverskriftHjelpOgInfo: 'Hjelp',
  mobilMenyOverskriftInnloggingInfo: 'Innlogging',
  hoppTilInnhold: 'Hopp Til Innhold',
  headerMenyLukkKnapp: 'Lukk',
  headerMenyKnapp: 'Meny',
  trekkspill: [{ contentGuid: '6b6d7da6-95f6-4592-aae5-83e492adffce', originalType: 'TrekkspillBlock' }],
  tilleggsinfo: [{ contentGuid: '40cb9a36-04a1-4c2c-a7ab-2885a03b70da', originalType: 'BlokkTekst' }],
  sidetittel: '<p>Foreldre&shy;signering</p>',
  sistePubliseringsdato: '2023-03-30T15:46:20+02:00',
  contentLink: {
    id: 9561,
    guid: '67f35123-1a74-4e02-85d0-bb3e3149280d',
    publicUri: 'https://localhost:11443/nb-NO/foreldresignering/',
  },
  parentId: 5879,
  visibleInMenu: false,
  urlSegment: 'foreldresignering',
  languageSiblings: null,
};
export type ForsideEpiContent = typeof forsideResponse;

export interface TrekkspillBlock {
  overskrift: string;
  trekkspillelementer: {
    contentGuid: string;
    originalType: string;
  }[];
}

export interface TilleggsinfoBlokk {
  overskrift: string;
  tekst: {
    value: string;
  };
}

export type LocaleCode = 'en-US' | 'nb-NO' | 'nn-NO';

export interface TrekkspillElementTekster {
  trekkspillMellomoverskrift: string;
  trekkspillTekstfelt: {
    value: string;
  };
}
